<template>
  <div>
    <div id="project_home">
        <div class="header-nav">
          <a class="tab-item"  v-for="(v, i) in menu_list" :key="i" @click="menuHandle(v)">{{v.cnName}}</a>
        </div>
        <div class="nav-wrap">
        <div class="nav-title">项目介绍</div> 
        <!--  {{$t("index").introduction}} -->
        </div>
      <div class="project-wrap project-page">
          <div class="project-list">
            <div class="project-item" @click="menuHandle(v)" :class="{'border-right': i !== projectList.length-1 && (i+1)%3 !==0}" v-for="(v, i) in projectList" :key="i">
              <img class="bg-img" :src="v.imgUrl || '/a'" @error="imgError('/img/fileimg.png')">
              <h2>{{v.cnName}}</h2>
              <div class="subTitle" v-html="reContents(v.described)"></div>
            </div>
          </div>
          <div class="news-list-item-wrap">
              <div class="news-list-item" @click="menuHandle(v)" :class="{'border-bottom': index!==projectList.length-1}" v-for="(v,index) in projectList" :key="index">
                <div class="news-list-item-img">
                  <img class="bg-img" :src="v.imgUrl || '/a'"  @error="imgError('/img/newimg.png')">
                </div>
                <div class="news-list-item-text">
                  <div class="title">{{v.cnName}}</div>
                  <div class="flex">
                    <div style="flex:1" class="subTitle" v-html="reContents(v.described)"></div>
                  </div>
                </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getColumns} from '@/api/home'
import { reContent,imgError } from '@/assets/utility'

export default {
  data() {
    return {
      menu_list: [],
      described: '',
      projectList: [],
      reContents: null
    }
  },
  mounted() {
    this.reContents = reContent
    getColumns('1242169895796736').then(res => {
      if(res) {
        this.projectList = res[0].subList
      }
    })
    getColumns(this.$route.params.cid).then(res => {
      if (res) {
        this.described = res[0].described
        this.menu_list = res[0].subList
        //this.$router.push(`list/${this.menu_list[0].colId}`)
      }
    })
  },
  methods: {
    menuHandle(pData) {
      this.$router.push(`list/${pData.colId}`)
    },
    imgError (url) {
      imgError(url)
    }
  }
}
</script>

<style lang="scss" scoped>
  #project_home {
    //padding: 0 rem(185) rem(185) rem(185);
    .project-menu {
      .menu-item {
        display: inline-block;
        text-align: center;
        color: #ffffff;
        background-color: #b50626;
        cursor: pointer;
      }
      .menu-item:first-child {
        background-color: #006b44;
      }
      .menu-item:last-child {
        background-color: #05459c;
      }
    }
  }
  .border-bottom {
    border-bottom: 1px solid #bfbfbf;
  }
  .project-wrap {
    padding: 0 rem(75);
    margin-bottom: rem(100);
    
    .subTitle {
      color:#999999;
      //font-size: 12px;
      overflow:hidden;
      line-height: 30px;
    }
    .project-item:hover{
      cursor: pointer;
    }
  }
  @media only screen and (min-width: 768px) {
    .news-list-item-wrap {
      display: none;
    }
    .project-title{
      text-align: left;
    }
    .nav-wrap{
      padding: 0 rem(135) 0 rem(75);
    }
    #project_home {
      .project-menu {
        .menu-item {
          margin-right: rem(30);
          width: rem(277);
          height: rem(65);
          line-height: rem(65);
          border-radius: rem(32.5);
          font-size: rem(26);
        }
      }
    }
  }
  @media only screen and (max-width: 768px) {
    .project-list {
      display: none;
    }
    .news-list-item-wrap {
      margin-top: .5rem;
    }
    #project_home {
      .project-menu {
        padding-top: .5rem;
        .menu-item {
          margin-right: .25rem;
          width: 1.6rem;
          height: .5rem;
          line-height: .5rem;
          border-radius: .25rem;
          font-size: .2rem;
        }
      }
    }
  }
</style>